import { tv } from "../../../variants/tv.js";
const radioGroupVariants = tv({
    slots: {
        radioGroup: 'relative flex flex-col items-start gap-3'
    },
    variants: {
        layout: {
            vertical: {},
            horizontal: {
                radioGroup: 'flex-row flex-wrap items-center justify-start gap-4'
            }
        }
    },
    compoundVariants: [],
    defaultVariants: {
        layout: 'vertical'
    }
});
export { radioGroupVariants };
